export default "* Jagt\n* Fiskeri\n* Våben\n* Redskaber\n* Mad fra jord til bord\n* Fortid\n* Nutid\n";